import * as React from 'react';

var _path, _path2, _path3;
function _extends() {
    return _extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, _extends.apply(null, arguments);
}
var SvgUnknown = function SvgUnknown(props) {
    return /*#__PURE__*/ React.createElement("svg", _extends({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none",
        viewBox: "0 0 120 120"
    }, props), _path || (_path = /*#__PURE__*/ React.createElement("path", {
        fill: "#fff",
        d: "M120 60c0 33.137-26.863 60-60 60S0 93.137 0 60 26.863 0 60 0s60 26.863 60 60"
    })), _path2 || (_path2 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        fillRule: "evenodd",
        d: "M60 115c30.376 0 55-24.624 55-55S90.376 5 60 5 5 29.624 5 60s24.624 55 55 55m0 5c33.137 0 60-26.863 60-60S93.137 0 60 0 0 26.863 0 60s26.863 60 60 60",
        clipRule: "evenodd"
    })), _path3 || (_path3 = /*#__PURE__*/ React.createElement("path", {
        fill: "#6B6580",
        d: "M64.088 75.264H53.72c-.192-1.248-.384-2.496-.384-3.936 0-5.088 2.112-9.792 7.584-13.92l4.608-3.456c2.88-2.112 4.128-4.704 4.128-7.584 0-4.416-3.168-8.64-9.6-8.64-6.816 0-9.792 5.472-9.792 10.848 0 1.152.096 2.208.384 3.072l-12.096-.48c-.384-1.344-.48-2.88-.48-4.32 0-10.368 7.776-20.352 21.984-20.352 14.88 0 22.656 9.408 22.656 19.104 0 7.584-3.84 12.96-9.504 16.992l-3.936 2.784c-3.36 2.4-5.184 5.376-5.184 9.312zm-12.576 13.92c0-4.224 3.36-7.68 7.584-7.68s7.68 3.456 7.68 7.68-3.456 7.584-7.68 7.584a7.54 7.54 0 0 1-7.584-7.584"
    })));
};

export { SvgUnknown as ReactComponent };
//# sourceMappingURL=Unknown.svg.es.js.map
